// extracted by mini-css-extract-plugin
export default {"container":"mp-z","heading":"np-z","text":"op-z","info":"pp-z","link":"qp-z","fullMaxWidth":"rp-z"};